import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'ANNOUNCEMENT_UPDATE',
    smsDelete : 'ANNOUNCEMENT_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        
        announcement:[],
        announcement_detail:{},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        announcementLoading: false,
        announcementError: false,
        ...store
    },

    mutations : {
        ...mutations,
       
   
        SET_ANNOUNCEMENT(state, announcement) {
            state.announcement = announcement;
        },
        SET_ANNOUNCEMENT_DETAIL(state, detail) {
            state.announcement_detail = detail;
        },
        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },
        ANNOUNCEMENT_LOADING (state, loading) {
            state.announcementLoading = loading;
        },

        ANNOUNCEMENT_ERROR (state, hasError) {
            state.announcementError = hasError;
        },
        
    },

    actions: {
 
        async addannouncement ({commit, dispatch}, payload) {
            commit('ANNOUNCEMENT_LOADING', true);
            commit('ANNOUNCEMENT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_announcement, payload.announcement, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
               
                return response

            }catch (e) {
                commit('ANNOUNCEMENT_ERROR', true);
            }finally {
                commit('ANNOUNCEMENT_LOADING', false);
            }
        },

        async fetchannouncementDetail ({ commit },payload) {
            commit('ANNOUNCEMENT_LOADING', true);
            commit('ANNOUNCEMENT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_announcement_detail + payload, config);
                let response = result.data.data

                commit('SET_ANNOUNCEMENT_DETAIL', response);

            } catch(error) {
                commit('ANNOUNCEMENT_ERROR', true);
            }
            finally {
                commit('ANNOUNCEMENT_LOADING', false);
            }
        },

        async fetchAnnouncement ({ commit }) {
            commit('ANNOUNCEMENT_LOADING', true);
            commit('ANNOUNCEMENT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_announcement_list, config);
                let response = result.data

                commit('SET_ANNOUNCEMENT', response.data);

            } catch(error) {
                commit('ANNOUNCEMENT_ERROR', true);
            }
            finally {
                commit('ANNOUNCEMENT_LOADING', false);
            }
        },

        async updateAnnouncement ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {

                let response = await axios.patch(V1API.update_announcement+payload.id, payload.announcement, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
               
                return response

            }catch (e) {
                commit('ANNOUNCEMENT_ERROR', true);
            }finally {
                commit('ANNOUNCEMENT_LOADING', false);
            }
        },
  
        async deleteAnnouncement({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_announcement + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchAnnouncement')
            
            return response
        },

    },

    getters: {}
}
